export function getChartGoogle() {
    let w: any = (typeof window !== "undefined")? window: null;
    let cg: any = (typeof w['google'] !== "undefined")? w['google']: null;


    w.control = function() {
        let elemts = w.document.getElementsByClassName("control");
        for(let i = 0; i < elemts.length; i++) {
            elemts[i].style.display = 'block';
        }
    }

    return cg;
}